document.addEventListener('livewire:navigated', function () {
    initializeFilterFeatures();
});

function initializeFilterFeatures() {
    'use strict';

    function saveActualScrollPosition() {
        localStorage.setItem('scrollPosition', window.scrollY);
    }

    function saveActualFilterControlsScrollPosition() {
        localStorage.setItem('filterControlsScrollPosition', $('.filter__controls')[0].scrollTop);
    }

    function removeActualScrollPosition() {
        localStorage.setItem('scrollPosition', false);
    }

    function removeActualfilterControlsScrollPosition() {
        localStorage.setItem('filterControlsScrollPosition', false);
    }

    function restoreScrollPosition() {
        const scrollPosition = localStorage.getItem('scrollPosition');
        if (!scrollPosition) {
            return;
        }
        window.scrollTo(0, scrollPosition, 'instant');
    }

    function restoreFilterControlsScrollPosition() {
        const scrollPosition = localStorage.getItem('filterControlsScrollPosition');
        if (!scrollPosition) {
            return;
        }
        $('.filter__controls')[0].scrollTop = parseInt(scrollPosition);
    }

    function openFilter() {
        $('body').addClass('filter-active');
    }

    function closeFilter() {
        $('body').removeClass('filter-active');
    }

    function saveFilterState(isOpen) {
        localStorage.setItem('filterOpen', isOpen);
    }

    function restoreFilterState() {
        const isOpen = localStorage.getItem('filterOpen');
        if (isOpen === 'true') {
            openFilter();
        } else {
            closeFilter();
        }
    }

    if ($('#filter').length) {
        // window.addEventListener('carFilter.paginated', event => {
        //     $('html, body').animate({
        //         scrollTop: $('#filterLivewire').offset().top
        //     }, 0);
        // });

        var updateFilterMobileAttribute = () => {
            var isMobile = $('#showFilter').is(':visible');
            var filterElement = document.getElementById('filterLivewire');

            if (filterElement) {
                const filter = eval(filterElement.getAttribute('data-livewire'));
                filter.set('isMobile', isMobile, true);
            }
        };

        document.addEventListener('livewire:navigated', () => {
            updateFilterMobileAttribute();
        });

        restoreFilterState();

        $('#showFilter').on('click', function(e) {
            openFilter();
            saveFilterState(true);
        });

        $('#hideFilter, #showResults').on('click', function(e) {
            closeFilter();
            saveFilterState(false);
        });

        $('.filter__backdrop').on('click', function(e) {
            closeFilter();
            saveFilterState(false);
        });

        $('#filter').on('click', '.filterChecksList__showBtn', function(e) {
            e.preventDefault();
            $(this).closest('.filterChecksList').find('.form-check').removeClass('d-none');
            $(this).addClass('d-none');
        });
    } else {
        removeActualScrollPosition();
        removeActualfilterControlsScrollPosition();
    }
}
